<template>
  <div>
    <base-header class="pb-6">
      <b-row class="align-items-center py-4">
        <b-col lg="6" cols="7">
          <h6 class="h2 text-white d-inline-block mb-0">User</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb />
          </nav>
        </b-col>
        <!--
        <b-col lg="6" cols="5" class="text-right">
          <base-button size="sm" type="neutral">New</base-button>
          <base-button size="sm" type="neutral">Filters</base-button>
        </b-col>
        -->
      </b-row>
    </base-header>

    <b-container fluid class="mt--6">
      <b-row>
        <b-col lg="12">
          <div class="card-wrapper">
            <!-- Input groups -->
            <card>
              <!-- Card header -->
              <h3 slot="header" class="mb-0">New User</h3>
              <!-- Card body -->
              <form>
                <!-- Input groups with icon -->
                <b-row>
                  <b-col md="4">
                    <base-input label="Username" placeholder="Your name" v-model="user.user_name"></base-input>
                  </b-col>
                  <b-col md="4">
                    <base-input label="Email" placeholder="Email" v-model="user.email"></base-input>
                  </b-col>
                  <b-col md="4">
                    <base-input label="Role">
                      <el-select v-model="selects.simple" filterable placeholder="Select Role">
                        <el-option v-for="option in selectOptions" :key="option.role_id" :label="option.role_name"
                          :value="option.role_id">
                        </el-option>
                      </el-select>
                    </base-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="4">
                    <base-input label="Password" placeholder="Password" :type="is_show_password ? 'text' : 'password'"
                      v-model="user.password">
                      <template #append>
                        <a href="javascript:void(0)" @click="is_show_password = !is_show_password">
                          <b-icon :icon="!is_show_password ? 'eye' : 'eye-slash'" class="text-muted"></b-icon>
                        </a>
                      </template>
                    </base-input>
                  </b-col>
                  <b-col md="4">
                    <base-input label="Password Confirmation" name="password_confirmation"  :type="is_show_confirm_password ? 'text' : 'password'"
                      placeholder="Password Confirmation" v-model="user.password_confirmation">
                      <template #append>
                        <a href="javascript:void(0)" @click="is_show_confirm_password = !is_show_confirm_password">
                          <b-icon :icon="!is_show_confirm_password ? 'eye' : 'eye-slash'" class="text-muted"></b-icon>
                        </a>
                      </template>
                    </base-input>
                  </b-col>
                </b-row>

                <h5 class="text-danger"> Note : <br><br>
                  <i>
                    1. Password must be at least 8 characters in length.
                  </i>
                  <br>
                  <i>
                    2. Password must contain at least one lowercase letter. [a-z].
                  </i>
                  <br>
                  <i>
                    3. Password must contain at least one uppercase letter. [A-Z].
                  </i>
                  <br>
                  <i>
                    4. Password must contain at least one number. [0-9].
                  </i>
                  <br>
                  <i>
                    5. Password must contain a special character from the list. [@$!%*#?&].
                  </i>
                  <br>
                </h5>

                <base-button type="primary" @click="createData()">Create / Save</base-button>
                <base-button type="primary" @click="$router.back()">Cancel</base-button>

              </form>
            </card>

          </div>
        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from 'element-ui'
import { apiGatewayDomain, getHeader } from '@/assets/js/config.js'
import axios from 'axios'
import notifyFunctionMixin from '@/assets/js/notifyFunctionMixin.js'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'

export default {
  mixins: [notifyFunctionMixin, clientPaginationMixin],
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      tableData: [],
      selectedRows: [],
      user: {
        user_name: null,
        email: null,
        password: null,
        password_confirmation: null,
      },
        is_show_password: false,
        is_show_confirm_password: false,
      selects: {
        simple: [],
      },
      selectOptions: [],
    }
  },
  created() {
    this.roleList()
  },
  methods: {
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows
    },
    createData() {
      const postData = {
        name: this.user.user_name,
        password: this.user.password,
        password_confirmation: this.user.password_confirmation,
        email: this.user.email,
        active_status: 1,
        role_id: this.selects.simple,
      }

      axios.post(apiGatewayDomain + 'setup/user', postData, { headers: getHeader() })
        .then(response => {
          if (response.status === 200) {
            this.$notify({
              message:
                '<b>New User : ' + response.data.data[0].name + '</b> - Successfully Created.',
              timeout: 10000,
              icon: 'ni ni-bell-55',
              type: 'default',
            });
            this.$router.back()
          }
        })
        .catch(error => {
          console.log(error.response.status)
          this.errorFunction(error, "Add User")

        });
    },
    roleList() {
      axios.get(apiGatewayDomain + 'setup/role', { headers: getHeader() })
        .then(response => {
          this.selectOptions = response.data.data
        })
        .catch(error => {
          console.log(error.response.status)
          this.errorFunction(error, "Show Role")
        });
    },

  },
  // beforeDestroy(){
  //   alert('asdsad');
  // }
}
</script>